var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DisplayConditionTypeComponents } from '../../../shared/domain/display.condition.type';
var ItemComponent = /** @class */ (function () {
    function ItemComponent() {
    }
    ItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setDisplayComponents();
        this.displayConditionForm.get('type').valueChanges.subscribe(function () { return _this.setDisplayComponents(); });
    };
    ItemComponent.prototype.setDisplayComponents = function () {
        this.displayComponents = DisplayConditionTypeComponents[this.displayConditionForm.get('type').value];
        this.dynamicInputs = __assign({ form: this.displayConditionForm }, this.displayComponents.inputs);
    };
    return ItemComponent;
}());
export { ItemComponent };
